import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2025 Smart Gate. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
